import type { Ref } from 'vue'
import { getBoolean, getRemoteConfig } from 'firebase/remote-config'
import { useFirebaseApp } from 'vuefire'

export function useFlag(name: string): Ref<boolean> {
  const remoteConfig = getRemoteConfig(useFirebaseApp())
  return ref(getBoolean(remoteConfig, name))
}
